import Icon from '@ant-design/icons'
import { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon'

// 取消归档
/* eslint-disable */
const Svg = () => (
  // eslint-disable-next-line
  <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M17.778 12.4431C17.778 11.2209 17.5558 10.1098 17.0002 8.9987L18.0002 8.44314C18.5558 9.66536 18.8891 10.9987 18.8891 12.332C18.8891 13.7765 18.5558 15.1098 18.0002 16.332L17.0002 15.8876C17.5558 14.8876 17.778 13.6654 17.778 12.4431ZM2.22244 12.4431C2.22244 13.5543 2.44466 14.6654 2.88911 15.6654L1.88911 15.9987C1.33355 14.8876 1.11133 13.6654 1.11133 12.332C1.11133 7.33203 5.11133 3.33203 10.0002 3.33203C11.4447 3.33203 12.8891 3.77648 14.1113 4.44314L13.6669 5.33203C12.5558 4.77648 11.3336 4.44314 10.0002 4.44314C5.77799 4.44314 2.22244 7.9987 2.22244 12.4431ZM12.8772 10.734L16.908 6.61203L16.1136 5.83425L12.1758 9.86214C11.5828 9.32657 10.8149 9 10.0003 9C8.22255 9 6.66699 10.5556 6.66699 12.4444C6.66699 14.3333 8.11144 15.8889 10.0003 15.8889C11.8892 15.8889 13.3337 14.3333 13.3337 12.4444C13.3337 11.8239 13.1658 11.2393 12.8772 10.734ZM12.3337 12.4444C12.3337 11.1111 11.3337 10 10.0003 10C8.66699 10 7.66699 11.1111 7.66699 12.4444C7.66699 13.7778 8.7781 14.8889 10.0003 14.8889C11.2225 14.8889 12.3337 13.7778 12.3337 12.4444Z" fill="url(#paint0_linear_3444_14398)" />
    <defs>
      <linearGradient id="paint0_linear_3444_14398" x1="1.11133" y1="9.83203" x2="18.8891" y2="9.83203" gradientUnits="userSpaceOnUse">
        <stop stopColor="#0CB6FF" />
        <stop offset="1" stopColor="#288EFF" />
      </linearGradient>
    </defs>
  </svg>
)

const IconComponent = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={Svg} {...props} />
)

export default IconComponent
